<template>
  <page-wrapper :title="pageWrapper.title" :hasPad="pageWrapper.hasPad">
    <div class="header text-right">
      <sc-button variant="secondary" :route="{ name: 'BannerPinnedPage' }">จัดลำดับการแสดงผล</sc-button>
    </div>
    <nav-tabs
      :tabs="tabs"
      :currentIndex="currentIndex"
      @onChangeTab="handleChangeTab"
    ></nav-tabs>
    <banner-list-item
      v-for="banner in currentBanners"
      :key="banner.id"
      :id="banner.id"
      :imageUrl="banner.imageUrl"
      :title="banner.title"
      :content="banner.content"
      :category="banner.category"
      :isPin="banner.isPinned"
      @onDelete="handleDelete(banner)"
    ></banner-list-item>
    <confirm
      v-show="deleteDialog.isShow"
      @confirm="handleConfirmDeleteDialog"
      :data="deleteDialog"
    ></confirm>
    <div class="wrapper text-right padding-adjust">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
        :page-size="10"
        :current-page="queryParams.page"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
  </page-wrapper>
</template>

<script>
import PageWrapper from "../../../lib/components/PageWrapper";
import NavTabs from "../../../lib/components/NavTabs";
import BannerListItem from "../components/BannerListItem";
import ScButton from "@/lib/components/ScButton";
import { articleUseCase } from "../../../dependencies.js";
import { Pagination } from "element-ui";

export default {
  components: {
    PageWrapper,
    NavTabs,
    BannerListItem,
    ScButton,
    "el-pagination": Pagination
  },
  created() {
    this.setup();
  },
  data() {
    const pageWrapper = {
      title: "แบนเนอร์",
      hasPad: false
    };

    const categories = [
      { key: "all", title: "ทั้งหมด" },
      { key: "news", title: "ข่าวประชาสัมพันธ์" },
      { key: "activities", title: "ข่าวกิจกรรม" },
      { key: "privileges", title: "ข่าวสิทธิพิเศษ" }
    ];

    const deleteDialog = {
      isShow: false,
      title: "",
      detail: "คุณแน่ใจหรือไม่ว่าต้องการลบแบนเนอร์นี้ ?",
      buttonCancel: "ยกเลิก",
      buttonSubmit: "ลบ"
    };

    const banners = [];
    const selectedBanner = null;
    const counts = {
      all: 0,
      news: 0,
      activities: 0,
      privileges: 0
    };

    return {
      pageWrapper,
      categories,
      deleteDialog,
      selectedBanner,
      banners,
      counts
    };
  },
  computed: {
    currentCategory() {
      return this.$route.query.category || "all";
    },
    total() {
      return this.counts[this.currentCategory];
    },
    tabs() {
      return this.categories.map(({ key, title }) => {
        let count = this.counts[key];

        return { title, count };
      });
    },
    currentIndex() {
      return this.categories.findIndex(
        ({ key }) => this.currentCategory === key
      );
    },
    currentBanners() {
      return this.banners;
    },
    queryParams() {
      return {
        articleTypeKeyword: this.currentCategory || "",
        page: parseInt(this.$route.query.page) || 1
      };
    }
  },
  methods: {
    async setup() {
      this.setupCurrentCategory();
      await this.setupBannerData();
    },
    setupCurrentCategory() {
      const { category = this.defaultCategory } = this.$route.query;

      this.updateTabByCategory(category);
    },
    async setupBannerData() {
      const { articleBanners, count } = await articleUseCase.listBanner(
        this.queryParams
      );

      this.banners = articleBanners;
      this.counts[this.queryParams.articleTypeKeyword || "all"] = count;
    },
    handleChangeTab(index) {
      const category = this.categories[index].key;

      this.$router.push({ name: "BannerList", query: { category, page: 1 } });
    },
    updateTabByCategory(category) {
      const route = {
        name: this.$route.name,
        query: { ...this.$route.query, category }
      };

      this.$router.replace(route);
    },
    handleDelete(banner) {
      this.deleteDialog.isShow = true;
      this.selectedBanner = banner;
    },
    handleCurrentChange(page) {
      const route = {
        name: this.$route.name,
        query: { ...this.$route.query, page }
      };

      this.$router.replace(route);
    },
    async handleConfirmDeleteDialog(isConfirm) {
      if (!isConfirm) {
        this.deleteDialog.isShow = false;
        this.selectedBanner = undefined;
        return;
      }

      const id = this.selectedBanner.id;
      await this.deleteBanner(id);
      await this.setupBannerData();

      this.selectedBanner = undefined;
      this.deleteDialog.isShow = false;
    },
    async deleteBanner(id) {
      await articleUseCase.deleteBanner(id);
    }
  },
  watch: {
    $route(to, from) {
      const needUpdateTab = to.name === "BannerList";

      if (!needUpdateTab) {
        return;
      }

      const { category } = to.query;

      this.updateTabByCategory(category);
      this.setupBannerData();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";
.header {
  justify-content: space-between;
  padding: 10px;
  background: #f9f9f9;
}
.padding-adjust {
  padding: 10px 0;
}
</style>



// WEBPACK FOOTER //
// src/features/articles/pages/BannerListPage.vue